import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Back from "../components/button/back";

const KURKUMedit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  /* ================= HALAMAN ASAL ================= */
  const redirectTo = location.state?.from || "/guru/elearning-guru";

  const [editedTP, setEditedTP] = useState({
    mapel: "",
    kelas: "",
    rombel: "",
    semester: "",
    TP: [],
  });

  const [notification, setNotification] = useState("");

  const updateNomorCP = (tpArray) =>
    tpArray.map((tp, idx) => ({ ...tp, nomor: `TP${idx + 1}` }));

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    const fetchTPData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/tp/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        setEditedTP({
          ...response.data,
          TP: updateNomorCP(response.data.TP),
        });
      } catch (error) {
        console.error("Error fetching TP data:", error);
      }
    };

    fetchTPData();
  }, [id, navigate]);

  /* ================= HANDLE TP ================= */
  const handleInputChange = (index, event) => {
    const updatedTP = [...editedTP.TP];
    updatedTP[index].isiTP = event.target.value;
    setEditedTP({ ...editedTP, TP: updatedTP });
  };

  const handleDeleteTP = (index) => {
    const updatedTP = editedTP.TP.filter((_, i) => i !== index);
    setEditedTP({ ...editedTP, TP: updateNomorCP(updatedTP) });
  };

  const handleAddTP = () => {
    const updatedTP = [...editedTP.TP, { isiTP: "" }];
    setEditedTP({ ...editedTP, TP: updateNomorCP(updatedTP) });
  };

  /* ================= SIMPAN ================= */
  const handleSaveChanges = async () => {
    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${process.env.REACT_APP_API_URL}api/tp/${id}`,
        editedTP,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setNotification("Perubahan berhasil disimpan!");
      setTimeout(() => {
        navigate(redirectTo);
      }, 1000);
    } catch (error) {
      console.error(error);
      setNotification("Gagal menyimpan perubahan");
    }
  };

  return (
    <div className="min-h-screen bg-blue-100 py-10">
      <div className="bg-white mx-5 rounded-lg drop-shadow-lg">
        <div className="flex justify-center py-5">
          <h1 className="font-bold text-2xl">Edit TP</h1>
        </div>

        {notification && (
          <p className="text-center text-green-600 font-semibold">
            {notification}
          </p>
        )}

        {/* ================= FORM ================= */}
        <div className="border rounded-lg mx-5 px-5 my-5">
          {["mapel", "kelas", "rombel", "semester"].map((field) => (
            <div key={field} className="flex gap-3 my-2">
              <label className="w-20 capitalize">{field}:</label>
              <input
                value={editedTP[field]}
                onChange={(e) =>
                  setEditedTP({ ...editedTP, [field]: e.target.value })
                }
                className="border rounded px-2 flex-1"
              />
            </div>
          ))}
        </div>

        {/* ================= DAFTAR TP ================= */}
        <div className="border rounded-lg p-5 mx-5">
          {editedTP.TP.map((tp, index) => (
            <div key={index} className="flex gap-3 mb-4">
              <div className="font-semibold w-16">{tp.nomor}</div>
              <textarea
                value={tp.isiTP}
                onChange={(e) => handleInputChange(index, e)}
                className="border rounded w-full h-[80px] p-2"
                maxLength={120}
              />
              <button
                onClick={() => handleDeleteTP(index)}
                className="bg-red-500 text-white px-3 rounded"
              >
                Hapus
              </button>
            </div>
          ))}

          <button
            onClick={handleAddTP}
            className="bg-green-500 text-white px-4 py-2 rounded"
          >
            Tambah TP
          </button>
        </div>

        {/* ================= SIMPAN ================= */}
        <div className="flex justify-center py-6">
          <button
            onClick={handleSaveChanges}
            className="bg-blue-500 text-white px-6 py-2 rounded"
          >
            Simpan Perubahan
          </button>
        </div>
      </div>

      {/* ================= KEMBALI ================= */}
      <div className="flex justify-center my-5">
        <button onClick={() => navigate(redirectTo)}>
          <Back />
        </button>
      </div>
    </div>
  );
};

export default KURKUMedit;
